import { Rule } from '../RuleBox'

const startingPriceRules: Array<Rule> = [
  {
    details: 'This makes the initial bid for the first four geotokens ~$50.',
    reason:
      'Since these are significant geotokens, we felt they should be fairly expensive to mint, but at the same time, we did not want to make them so exclusive that only a few people could bid on them.',
    summary: 'Starting Minimum Minting Deposit for the first four geotokens is 100k XYO each',
  },
  {
    details:
      'When the four child geotokens of a sold geotoken become available, each of their minimum minting deposits are 50% of the parent minting deposit amount.',
    reason:
      'Since each geotoken would normally have different values for their children, we would expect 1 or 2 to go to a Dutch Auction in that case and normalize the price.',
    summary: 'The starting minimum minting deposit for geotokens is 50% of minting deposit amount of parent geotoken',
  },
]

export default startingPriceRules
